

import { AddProviderPayload, UpdateProviderPayload } from "../../redux/providers/providerTypes";
import { Provider, ProviderList } from "../../types/Provider";
import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = "/providers";

export const saveProviderApi = async (provider: AddProviderPayload):Promise<any> => {
  try {
    let newProvider= mapToCreateProvider(provider.data)
    const response = await api.create(`${baseUrl}`, newProvider);
    return  response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : new Error('Error de conexión');
  }
} 

export const updateProviderApi = async (user: UpdateProviderPayload):Promise<any> => {
  try {

    let providerToUpdate = mapToUpdateProvider(user.data)

    const response = await api.update(`${baseUrl}`, providerToUpdate);;
    return response.data;
   return null;
  } catch (error: any) {
    throw error.response ? error.response.data : new Error('Error de conexión');
  }
}

export const getProvidersApi = async ():Promise<Provider[]> => {
  try {
    const response = await api.get(`${baseUrl}/all`, '');
    const providers: ProviderList[] = response.data; 
    let result=   providers.map(provider => mapProvider(provider));
    return result;  

  } catch (error: any) {
    throw error.response ? error.response.data : new Error('Error de conexión');
  }
}

export const getProviderByUserApi = async (idUser : number):Promise<ProviderList> => {
  try {
    const response = await api.get(`${baseUrl}/user/${idUser}`,'');
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : new Error('Error de conexión');
  }
}

export const getProviderByIdEnterpriseApi = async (id : number):Promise<ProviderList[]> => {
  try {
    const response = await api.get(`${baseUrl}/enterprise/${id}`,'');
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : new Error('Error de conexión');
  }
}


export const deleteProviderApi = async ( id: number): Promise<Boolean> => {
  try {
    const response = await api.delete(`${baseUrl}/${id}`);
    if (response.status === 200) {
      return true; 
    } else {
      throw new Error('Error al eliminar el proveedor');
    }
  } catch (error: any) {
    if (error.response) {
      const errorMessage = error.response?.data?.message || 'Error de servidor';
      throw new Error(errorMessage);
    } else {
      throw new Error('Error de conexión');
    }
  }
}

const mapProvider = (provider: ProviderList): Provider =>{
  return {
    id: provider.id,
    enterprise: provider.enterprise.name, 
    enterpriseId: provider.enterprise.id,
    degree: provider.degree,
    position: provider.position,
    email: provider.user?.email ?? '',
    surname: provider.user?.surname ?? '',
    name: provider.user?.name ?? '',
    lastname: provider.user?.lastname ?? '',
    cellPhone: provider.user?.cellPhone ?? '',
    password: provider.user?.password ?? '',
    idUser: provider.user?.id ?? null,
    optionalEmail: provider.user?.optionalEmail ?? null,
    localPhone: provider.user?.localPhone ?? null,
    localExtension: provider.user?.localExtension ?? null,
    directPhone: provider.user?.directPhone ?? null,
    directExtension: provider.user?.directExtension ?? null,
    officePhone: provider.officePhone ?? null,
    officeExtension: provider.officeExtension ?? null,
    companyLink: provider.companyLink ?? null,
    optionalCellPhone: provider.user?.optionalCellPhone ?? null,
    avatarLink: provider.user?.avatarLink ?? null,
    role: provider.user?.role ?? null,
    hospital: provider.user?.hospital ?? null,
    area: provider.user?.area ?? null,
  };
}

const mapToCreateProvider = (provider: any):any =>{

  return {
    enterprise: provider.enterprise, 
    degree: provider.degree || '',
    position: provider.position || '',
    professionalLicense: provider.professionalLicense ?? false,
    officePhone: provider.officePhone ?? '',
    officeExtension: provider.officeExtension ?? '',
    companyLink: provider.companyLink ?? '',
    user: {
      email: provider.email ?? '',
      password: provider.password ?? '',
      name: provider.name ?? '',
      surname: provider.surname ?? '',
      lastname: provider.lastname ?? '',
      optionalEmail: provider.optionalEmail ?? null,
      localPhone: provider.localPhone ?? null,
      localExtension: provider.localExtension ?? null,
      directPhone: provider.directPhone ?? null,
      directExtension: provider.directExtension ?? null,
      cellPhone: provider.cellPhone ?? '',
      optionalCellPhone: provider.optionalCellPhone ?? null,
      avatarLink: provider.avatarLink ?? null,
      role: provider.role ?? 0,
      hospital: provider.hospital ?? 0,
      area: provider.area ?? 0,
    },
  };
}



const mapToUpdateProvider = (provider: any):any =>{

  return {
    id: provider.id,
    enterprise: provider.enterprise, 
    degree: provider.degree || '',
    position: provider.position || '',
    professionalLicense: provider.professionalLicense ?? false,
    officePhone: provider.officePhone ?? '',
    officeExtension: provider.officeExtension ?? '',
    companyLink: provider.companyLink ?? '',
    user: {
      id:provider.idUser,
      email: provider.email ?? '',
      password: provider.password ?? '',
      name: provider.name ?? '',
      surname: provider.surname ?? '',
      lastname: provider.lastname ?? '',
      optionalEmail: provider.optionalEmail ?? null,
      localPhone: provider.localPhone ?? null,
      localExtension: provider.localExtension ?? null,
      directPhone: provider.directPhone ?? null,
      directExtension: provider.directExtension ?? null,
      cellPhone: provider.cellPhone ?? '',
      optionalCellPhone: provider.optionalCellPhone ?? null,
      avatarLink: provider.avatarLink ?? null,
      role: provider.role ?? 0,
      hospital: provider.hospital ?? 0,
      area: provider.area ?? 0,
    },
  };
}